export const events = {
  // create meeting events
  CreateMeetingStart: 'Open create meeting',
  CreateMeetingSuccess: 'Success creating meeting',
  CreateMeetingError: 'Error creating meeting',
  // meeting notes events
  MeetingNotesPreMeeetingAIBlockStart: 'Meeting notes pre meeting ai block start',
  MeetingNotesPreMeeetingAIBlockSuccess: 'Meeting notes pre meeting ai block success',
  MeetingNotesPreMeeetingAIBlockError: 'Meeting notes pre meeting ai block error',
  MeetingNotesPostMeeetingAIBlockStart: 'Meeting notes post meeting ai block start',
  MeetingNotesPostMeeetingAIBlockSuccess: 'Meeting notes post meeting ai block success',
  MeetingNotesPostMeeetingAIBlockError: 'Meeting notes post meeting ai block error',
  // prejoin events
  MeetingPrejoinEnter: 'Meeting prejoin enter',
  PrejoinAudioInputChange: 'Prejoin audio input change',
  PrejoinVideoInputChange: 'Prejoin video input change',
  PrejoinAudioOutputChange: 'Prejoin audio output change',
  PrejoinBackgroundChange: 'Prejoin background change',
  // room control bar events
  ControlBarMuteButton: 'Control bar mute button',
  ControlBarVideoButton: 'Control bar video button',
  ControlBarScreenShareButton: 'Control bar screen share button',
  ControlBarLeaveButton: 'Control bar leave button',
  ControlBarChatButton: 'Control bar chat button',
  ControlBarSideBarButton: 'Control bar side bar button',
  ControlBarSettingsButton: 'Control bar settings button',
  // settings modal events
  SettingsModalAudioInputChange: 'Settings modal audio input change',
  SettingsModalVideoInputChange: 'Settings modal video input change',
  SettingsModalAudioOutputChange: 'Settings modal audio output change',
  SettingsModalBackgroundChange: 'Settings modal background change',
  SettingsModalSoundEffectsChange: 'Settings modal sound effects change',
  // room events
  RoomOpenAIchat: 'Room AI chat open',
  RoomOpenNotes: 'Room Notes open',
  RoomOpenTranscript: 'Room Transcript open',
  ChatSendMessage: 'Chat send message',
}
